<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-card>
            <v-card-title id="heading" class="bg-white position-fixed w-100 z-index-9">
                <div class="d-flex justify-space-between">
                    <h4>{{ role.title }} Permissions</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </div>
            </v-card-title>

            <v-container class="mt-10 mb-5">
                <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                         density="compact" variant="tonal">
                    <p v-for="error in errors">{{ error }}</p>
                </v-alert>

                <v-row v-for="(routes_list,group_name) in routes">
                    <v-col class="py-0" cols="12">
                        <h3 class="text-capitalize">
                            {{ `${group_name.replace('.', ' ').replace('-', ' ').replace('.', ' ')}` }}</h3>
                    </v-col>
                    <v-col v-for="route in routes_list" class="py-0" cols="4">
                        <v-switch v-model="permissions" :label="`${routeName(route)}`"
                                  :value="`${group_name !== route? group_name+'.'+route:route}`"
                                  color="primary"
                                  density="compact"/>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 bg-white position-fixed w-100 z-index-9 bottom-0">
                <div class="d-flex justify-end">
                    <v-btn :disabled="!permissions.length" color="primary" size="small" @click="updatePermissions">
                        Save
                    </v-btn>
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    role: {
        type: Object
    }
});

const emits = defineEmits(['update:modelValue']);
const dialogSwitch = ref(props.modelValue);
const permissions = ref([]);
const routes = ref([]);
const errors = ref([]);

onMounted(() => {
    fetchPermissions();
});

const routeName = (route) => {
    switch (route) {
        case 'index':
            route = 'list view';
            break;
        case 'show':
            route = 'single record view';
            break;
        case 'store':
            route = 'create';
            break;
        case 'update':
            route = 'edit';
            break;
        case 'destroy':
            route = 'delete';
            break;
    }
    return route.replace(/^\w/, c => c.toUpperCase());
}
const fetchPermissions = () => {
    send('get', `admin/roles/permissions?role=${props.role.id}`)
        .then((response) => {
            permissions.value = response.data.data.permissions;
            routes.value = response.data.data.routes;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Permissions could not be loaded', 'error')
        })
}
const updatePermissions = () => {
    errors.value = [];
    send('post', `admin/roles/permissions`, {role: props.role.id, routes: permissions.value})
        .then((response) => {
            showSnackbar(response.data.message);
            if (response.data.success) {
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>

<style scoped>
.z-index-9 {
    z-index: 9;
}
</style>
